import React from 'react';
import { Box, Typography } from '@mui/material';
import { Container, Row, Col, Image } from 'react-bootstrap';
import awardImg from '../Assets/Images/awardSet.png';
const Awards = () => {
  return (
    <>
        <Box className="awardMain">
            <Box className="awardoverlay"></Box>
            <Box className="awardWraper">
                <Container>
                    <Row>
                        <Col lg={7} className='relative'>
                            <Box className="awardTxtOverlay"></Box>
                            <Box className="awardsInfo">
                                <Typography variant="h6" style={{ color:'#fff', borderColor: '#fff'}} >Awards And Recognition</Typography>
                                <Typography variant="h2" style={{fontSize: '45px', color:'#fff'}}>2024 ET Leadership Excellence Award by Times of India</Typography>
                                <Typography variant="body1" component="p" style={{ color:'#fff'}}>
                                Shankh Air is super excited and proud to share some great news! Our respected Chairman, Mr. Sharvan Kumar Vishwakarma, has won the famous ET Leadership Excellence Award 2024 from the Times of India. This is a big and happy moment for everyone here! This award shows how wonderful his leadership is and how clever his ideas are. He works hard every day to make Shankh Air a well-known name in air travel. He has lifted the company to new heights with his smart plans and strong effort. But he didn’t do it all by himself—our amazing team has helped a lot too!
                                </Typography>

                                <Typography variant="body1" component="p" style={{ color:'#fff'}}>
                                Together, with Mr. Vishwakarma’s guidance and the team’s hard work, Shankh Air has grown big and become famous for giving top-class service to passengers. This special award proves his nonstop drive to make everything better and keep high standards. It also shows that Shankh Air, like a family, is serious about great travel experiences. We are so thankful to him for leading us so well and to our awesome team for shining like stars. This honor makes us proud and ready to do even more big things ahead!
                                </Typography>
                            </Box>
                        </Col>
                        <Col lg={5}>
                            <Box className="awardImg">
                                <Image src={awardImg} className='img-fluid'></Image>
                            </Box>
                        </Col>
                    </Row>
                </Container>
            </Box>
        </Box>      
    </>
  )
}

export default Awards
